export enum VisitorDrawerState {
  CHAT = 'CHAT',
  INTENTIONS = 'INTENTIONS',
  PENDING_FORMS = 'PENDING_FORMS',
  PENDING_FORMS_COMPLETED = 'PENDING_FORMS_COMPLETED',
  REFLECTION_TOPICS = 'REFLECTION_TOPICS',
  SETTINGS = 'SETTINGS',
}
